<template>
  <div class="sidebar" data-color="light-gray" data-background-color="dark-gray">
    <div class="logo">
      <a href="/"
         class="simple-text logo-mini"
         style="margin-left: 20px; width: 50px; margin-right: 5px">
        <img src="/img/solarmap.png" style="height: 35px;"/>
      </a>
      <a href="/" class="simple-text logo-normal" style="line-height: 35px;"> Solarmap </a>
    </div>
    <div class="sidebar-wrapper">
      <div class="user">
        <div class="photo">
          <img src="/img/hcc.jpeg" style="height: 30px; width: 30px;" />
        </div>
        <div class="user-info">
          <a data-toggle="collapse" href="#profileCollapse" class="username">
            <span>
              {{ usuario.nome }}
              <b class="caret"></b>
            </span>
          </a>
          <div class="collapse" id="profileCollapse">
            <ul class="nav">
              <li class="nav-item" v-for="(m, i) in usuario.menu" :key="i">
                <a v-if="m.acao == 'sair'" class="nav-link" href="#" @click="acao(m.acao)">
                  <span class="sidebar-mini">
                    {{ m.nome.substring(0, 2).toUpperCase() }}
                  </span>
                  <span class="sidebar-normal"> {{ m.nome }} </span>
                </a>
                <a v-else class="nav-link" :href="m.acao" @click="acao(m.acao)">
                  <span class="sidebar-mini">
                    {{ m.nome.substring(0, 2).toUpperCase() }}
                  </span>
                  <span class="sidebar-normal"> {{ m.nome }} </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ul class="nav">
        <li :class="temAcao(m) ? 'nav-item active' : 'nav-item'"
            v-for="(m, i) in menu"
            :key="i">
          <a class="nav-link"
             :data-toggle="m.menus ? 'collapse' : ''"
             :href="m.acao ? m.acao : '#menu-' + i + '-colap'"
             @click="acao(m.acao)">
            <i :class="m.icone"></i>
            <p>
              {{ m.nome }}
              <b v-if="m.menus" class="caret"></b>
            </p>
          </a>
          <div class="collapse" :id="'menu-' + i + '-colap'" v-if="m.menus">
            <ul class="nav">
              <li :class="s.acao == acaoAtual ? 'nav-item active' : 'nav-item'"
                  v-for="(s, si) in m.menus"
                  :key="si">
                <a class="nav-link" :href="s.acao" @click="acao(s.acao)">
                  <span class="sidebar-mini">
                    {{ s.nome.substring(0, 2) }}
                  </span>
                  <span class="sidebar-normal"> {{ s.nome }} </span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <div class="sidebar-background"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      usuario: {
        nome: "",
        menu: [
          /*{ nome: "Meu perfil", acao: "" },*/
          { nome: "Alterar senha", acao: "/alterar-senha" },
          { nome: "Sair", acao: "sair" }
        ],
      },
      menu: [],
      acaoAtual: window.location.pathname,
    };
  },
  methods: {
    acao(acao) {
      if (acao) {
        this.acaoAtual = acao;
      }

      if ( acao == "sair" ) {
        this.logout();
      }
    },
    temAcao(a) {
      if (a.acao == this.acaoAtual) {
        return true;
      }
      if (a.menus) {
        for (const key in a.menus) {
          if (a.menus[key].acao == this.acaoAtual) {
            return true;
          }
        }
      }
      return false;
    },
    logout() {
      callAPI(
        '/logout',
        'POST',
        null,
        (e) => {
          localStorage.removeItem('token');
          window.location = '/login';
        }
      );
    }
  },
  mounted() {
    callAPI(
      '/user',
      'GET',
      null,
      (e) => {
        this.usuario.nome = e.name;
      }
    );
    
    callAPI(
      '/menu',
      'GET',
      null,
      (e) => {
        this.menu = e;
      }
    );
  }
};
</script>

<style scoped>
.sidebar, .sidebar-wrapper {
  background-color: #0f172a !important; /* Dark Navy */
  box-shadow: 2px 0 10px rgba(0,0,0,0.1);
}
.sidebar .logo {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}
.sidebar .logo .simple-text {
  color: #ffffff !important;
  font-family: 'Inter', sans-serif !important;
  font-weight: 700;
  text-transform: none;
}
.sidebar .nav p, .sidebar .nav .sidebar-normal, .sidebar .nav .sidebar-mini {
  color: #94a3b8 !important;
  font-family: 'Inter', sans-serif !important;
  font-weight: 500;
}
.sidebar .nav i {
  color: #94a3b8 !important;
}
.sidebar .nav li.active > a {
  background-color: rgba(251, 191, 36, 0.1) !important; /* Soft yellow tint */
  border-radius: 8px;
  margin-left: 10px;
  margin-right: 10px;
  width: calc(100% - 20px);
}
.sidebar .nav li.active > a p, 
.sidebar .nav li.active > a i,
.sidebar .nav li.active > a .sidebar-normal,
.sidebar .nav li.active > a .sidebar-mini {
  color: #fbbf24 !important; /* Vibrant yellow */
  font-weight: 600;
}
.sidebar .nav li:hover:not(.active) > a {
  background-color: rgba(255, 255, 255, 0.05) !important;
  border-radius: 8px;
  margin-left: 10px;
  margin-right: 10px;
  width: calc(100% - 20px);
}
.sidebar .nav li:hover:not(.active) > a p,
.sidebar .nav li:hover:not(.active) > a i,
.sidebar .nav li:hover:not(.active) > a .sidebar-normal,
.sidebar .nav li:hover:not(.active) > a .sidebar-mini {
  color: #ffffff !important;
}
.sidebar .user {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}
.sidebar .user .photo {
  border: 2px solid #334155;
}
.sidebar .user a span {
  color: #e2e8f0 !important;
}
.sidebar-background {
  display: none !important;
}
</style>